import styled from 'styled-components'

import { applyIPadOnlyStyle, getResponsiveFontSizeCSS } from 'helpers/css'

export const Container = styled.div`
    background: #ffffff;
    border-radius: 16px;
    display: flex;
    flex-direction: column;
    justify-content: ${props => props.justifyContent || 'space-evenly'};
    padding: 15px;
    height: 100%;

    ${applyIPadOnlyStyle(
        'background:#555555, align-items: center, padding: 0 25px',
        {
            min: 0,
            max: 1370,
            orientation: 'both',
        }
    )}

${applyIPadOnlyStyle('padding: 30px 25px', {
    min: 701,
    max: 1370,
    orientation: 'both',
})}

    ${applyIPadOnlyStyle(
        'max-height: 95vh, max-width: 90vw, padding: 15px 3vw',
        {
            min: 0,
            max: 1370,
            orientation: 'both',
        }
    )}

    ${applyIPadOnlyStyle('min-width: 90vw', {
        min: 0,
        max: 360,
        orientation: 'both',
    })}
`

export const ImagesContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    width: ${({ width }) => `${width}%`};
    margin: 30px 0;
    ${applyIPadOnlyStyle('width: 100%, max-width: 500px, margin: 10px 0', {
        min: 0,
        max: 1370,
        orientation: 'both',
    })}
`

export const DeviceImage = styled.div`
    flex: 1;
    max-width: 120px;
    min-width: 80px;
    min-height: 100px;
    margin: 0px 5px;
`

export const LaptopImage = styled(DeviceImage)`
    background: url('/img/checklist/laptop.svg') center no-repeat;
    background-size: contain;
    @media (max-width: 1370px) {
        background: url('/img/checklist/laptop-dark.svg') center no-repeat;
        background-size: contain;
    }
`

export const MobileImage = styled(DeviceImage)`
    background: url('/img/checklist/mobile.svg') center no-repeat;
    background-size: contain;
    @media (max-width: 1370px) {
        background: url('/img/checklist/mobile-dark.svg') center no-repeat;
        background-size: contain;
    }
`

export const IpadImage = styled(DeviceImage)`
    background: url('/img/checklist/iPad.svg') center no-repeat;
    background-size: contain;
    @media (max-width: 1370px) {
        background: url('/img/checklist/iPad-dark.svg') center no-repeat;
        background-size: contain;
    }
`

export const LinkTextSmall = styled.a`
    color: var(--oh-orange);
    font-family: AvenirBold;
    font-size: ${getResponsiveFontSizeCSS(14, 16)};
    font-style: normal;
    font-weight: 600;
    text-align: left;
    cursor: pointer;
`

export const CopyTextInput = styled.p`
    color: #219653;
    font-family: Avenir;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 17px;
    letter-spacing: 0em;
    text-align: left;
    text-decoration: none;
    border-color: transparent;
    margin: 15px 0;

    ${applyIPadOnlyStyle('font-size: 12px', {
        min: 0,
        max: 360,
        orientation: 'both',
    })}
`

export const List = styled.ul`
    padding: 0;
    margin: 0;
`
export const ListLi = styled.li`
    font-family: Avenir;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 17px;
    letter-spacing: 0em;
    text-align: left;
    color: 555555;
    margin-bottom: 15px;

    ${applyIPadOnlyStyle('color: white', {
        min: 0,
        max: 1370,
        orientation: 'both',
    })}
`

export const ImageCopy = styled.img`
    cursor: pointer;
    margin-left: 25px;
`

export const ChromeButton = styled.button`
    background: #ffffff;
    box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.1);
    border-radius: 10px;
    border: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px 15px;
    font-family: Avenir;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 17px;
    letter-spacing: 0em;
    text-align: left;
    cursor: pointer;

    ${applyIPadOnlyStyle(
        'background: transparent, color: white, border: 0.5px white solid, margin-right: 10px;',
        {
            min: 0,
            max: 1370,
            orientation: 'both',
        }
    )}
`

export const InstallChrome = styled.a`
    font-family: Avenir;
    font-size: 17px;
    font-style: normal;
    font-weight: 600;
    line-height: 21px;
    letter-spacing: 0em;
    text-align: left;
    color: #e87d7c;
    margin-left: 20px;
    ${applyIPadOnlyStyle('margin-left: 0px, margin-top: 15px', {
        min: 0,
        max: 1370,
        orientation: 'both',
    })}
`
export const ChromeContainer = styled.div`
    display: flex;
    align-items: center;
    @media only screen and (max-width: 900px) {
        flex-direction: column;
        align-items: flex-start;
    }

    ${applyIPadOnlyStyle(
        'width: 80%, flex-direction: row, justify-content: space-between',
        {
            min: 0,
            max: 900,
            orientation: 'landscape',
        }
    )}
`

export const CenteredAlign = styled.div`
    font-family: Avenir;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 20px;
    letter-spacing: 0em;
    text-align: left;
    color: #555555;
    display: flex;
    align-items: center;
`

export const Maintext = styled.div`
    font-family: Avenir;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 20px;
    letter-spacing: 0em;
    text-align: left;
    margin-top: 20px;
    color: #555555;
    @media only screen and (max-width: 900px) {
    }
    ${applyIPadOnlyStyle('color: white, font-size: 14px, width: 100%', {
        min: 0,
        max: 1370,
        orientation: 'both',
    })}
`

export const NetworkWrapper = styled(Maintext)`
    margin: 0;
`

export const BrowserWrapper = styled.div`
    margin-top: 5px;
    display: flex;
    align-items: flex-start;
    flex-direction: column;

    ${applyIPadOnlyStyle('margin-top: 10px, width: 100%;', {
        min: 0,
        max: 1370,
        orientation: 'both',
    })}
`

export const LeftTextWithImageDiv = styled.div`
    font-family: Avenir;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 20px;
    letter-spacing: 0em;
    text-align: left;
    color: #555555;
    margin: 20px 0;
    ${applyIPadOnlyStyle('color: white', {
        min: 0,
        max: 1370,
        orientation: 'both',
    })}
`

export const ParticipantNotAllowedWrap = styled.div`
    display: flex;
    justify-content: center;
    flex-direction: column;
    padding: 7%;
`

export const Title = styled.div`
    font-family: AvenirBold;
    text-align: center;
    font-size: 20px;
    line-height: 24px;
    letter-spacing: -0.01em;
    color: #555555;
    margin-bottom: 10px;
    ${applyIPadOnlyStyle('color:white', {
        min: 0,
        max: 1370,
        orientation: 'both',
    })}
`

export const Info = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    width: max-content;
    margin: 3vh 0 1vh;
    width: 100%;
    & > div {
        margin: 0px 5px;
    }
`

export const Icon = styled.div`
    background: #f3c520;

    width: 20px;
    height: 20px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
    font-weight: bolder;

    ::after {
        content: 'i';
    }
`

export const Text = styled.div`
    font-style: normal;
    font-size: 14px;
    line-height: 17px;
    text-align: center;
    color: #555555;

    ${applyIPadOnlyStyle('color:white, font-size: 16px', {
        min: 0,
        max: 1370,
        orientation: 'both',
    })}
`

export const CtaTitle = styled.p`
    font-weight: 600;
    font-size: 14px;
    line-height: 17px;
    text-align: center;

    margin: 3vh 0 2vh;
    ${applyIPadOnlyStyle('color:white', {
        min: 0,
        max: 1370,
        orientation: 'both',
    })}
`

export const CtaSection = styled.div`
    width: 100%;
    margin-top: 1vh;
`

export const CtaBtns = styled.div`
    display: flex;
    width: 100%;
`

export const BtnWithSubText = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
`
